import { Provider, EnvironmentProviders, provideAppInitializer, inject } from '@angular/core';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { OAuthAuthService } from './oauth-auth.service';
import { AuthConfig } from 'angular-oauth2-oidc';

/**
 * @param config - Configuración OAuth requerida. Debe ser proporcionada por la aplicación.
 */
export function provideOAuthAuth(config: AuthConfig): (Provider | EnvironmentProviders)[] {
  if (!config) {
    throw new Error('OAuth configuration is required. Please provide an AuthConfig object.');
  }

  const authConfig = config;

  return [
    // Proveer OAuthClient con la configuración (necesario para PKCE)
    provideOAuthClient({
      resourceServer: {
        allowedUrls: [],
        sendAccessToken: false,
      },
    }),
    // OAuthAuthService que envuelve OAuthService
    OAuthAuthService,
    provideAppInitializer((): Promise<void> => {
      const oauthAuthService = inject(OAuthAuthService);
      return oauthAuthService.configure(authConfig);
    }),
  ];
}
